import { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { getDoors } from '../AccessPoint/actionCreators';
import { getInviteInfo } from './actionCreators';

import { formatSelect, notNullOrUndefined, required } from '../Forms/utils';
import { filterVisitorDoors, formatDoorName } from './utils';

import { ELECTRONIC_KEY_PERIOD_OPTIONS } from './constants';

import { CHECKBOX, REACT_SELECT_INPUT } from '../Forms/fieldTypes';

const form = 'SendInviteForm';

const SendInviteFormComponent = (props) => {
  const {
    inviteModalData: { isInviteUpdate, visitor, buildingId },
    getInviteInfo,
    buildingDoors,
    getDoors,
    initialValues,
    onSubmit,
  } = props;

  useEffect(() => {
    getDoors({}, buildingId);
    isInviteUpdate && getInviteInfo(visitor?.id);
  }, []);

  const doors = filterVisitorDoors(buildingDoors, visitor);
  const doorsOptions = formatSelect(Object.values(doors));
  const formData = [
    {
      label: 'Period',
      keyName: 'period',
      fieldType: REACT_SELECT_INPUT,
      options: ELECTRONIC_KEY_PERIOD_OPTIONS,
      validate: [required],
    },
    {
      label: 'Doors',
      keyName: 'doors',
      fieldType: REACT_SELECT_INPUT,
      multi: true,
      options: doorsOptions,
      validate: [required],
    },
    {
      label: 'Send Invite',
      keyName: 'sendInvite',
      fieldType: CHECKBOX,
      validate: [notNullOrUndefined],
      isHidden: !isInviteUpdate,
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      submitText="Send"
      backButton={false}
      isFullWidthForm
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmit}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const { visitors, doors } = state;
  const {
    inviteModalData: { isInviteUpdate, buildingId },
  } = ownProps;

  const initialValues = {
    sendInvite: false,
  };

  if (isInviteUpdate) {
    initialValues.period = visitors?.inviteInfo?.period || 'unlimited';
    initialValues.doors = visitors?.inviteInfo?.doors;
  }
  const buildingDoors = [...doors].filter(
    ({ building }) => building === buildingId,
  );
  const formattedBuildingDoors = formatDoorName(buildingDoors);

  return {
    initialValues,
    buildingDoors: formattedBuildingDoors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getInviteInfo: (visitorId) => getInviteInfo(dispatch, visitorId),
  getDoors: (queryParams, buildingId) =>
    getDoors(dispatch, queryParams, buildingId),
});

SendInviteFormComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  inviteModalData: PropTypes.shape({
    isInviteUpdate: PropTypes.bool.isRequired,
    visitor: PropTypes.shape({
      id: PropTypes.number.isRequired,
      unit: PropTypes.number,
    }).isRequired,
    buildingId: PropTypes.number.isRequired,
  }).isRequired,
  getDoors: PropTypes.func.isRequired,
  getInviteInfo: PropTypes.func.isRequired,
  buildingDoors: PropTypes.instanceOf(Array).isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SendInviteFormComponent);
